export default "__VITE_ASSET__5X53qkNc__"